import React from "react";
import { array, string, func, object } from "prop-types";

import "./selectDropdown.m.css";

const SelectDropdown = ({ name, label, defaultItem, list, selected, onChange, className, selectClassName }) => {
  if (!(list && list.length) && !defaultItem) {
    return null;
  }

  if (typeof window === "undefined") {
    return null;
  }

  return (
    <div styleName="wrapper" className={className}>
      {label && <label styleName="label">{label}</label>}
      <select
        name={name}
        styleName="select-wrapper"
        className={selectClassName}
        value={selected || ""}
        onChange={onChange}
      >
        {defaultItem ? <option value={defaultItem["external-id"]}>{defaultItem.name}</option> : null}
        {list && list.length
          ? list.map((item, index) => (
              <option key={index} value={item["external-id"]}>
                {item.name}
              </option>
            ))
          : null}
      </select>
    </div>
  );
};

SelectDropdown.defaultProps = {
  className: "",
  name: "dropdown-select",
  selectClassName: "select-wrapper",
};

SelectDropdown.propTypes = {
  selected: string,
  onChange: func,
  defaultItem: object,
  label: string,
  list: array.isRequired,
  className: string,
  selectClassName: string,
  name: string,
};

export default SelectDropdown;
